var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.944,
    height: 47.5,
    viewBox: "0 0 48.944 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-418.056 -316.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M5.374 35.833A5.38 5.38 0 0 1 0 30.459V5.374A5.38 5.38 0 0 1 5.374 0h14.334a5.382 5.382 0 0 1 5.376 5.374v25.085a5.382 5.382 0 0 1-5.376 5.374zM3.583 5.374v25.085a1.793 1.793 0 0 0 1.791 1.791h14.334a1.793 1.793 0 0 0 1.792-1.791V5.374a1.793 1.793 0 0 0-1.791-1.791H5.374a1.793 1.793 0 0 0-1.791 1.791zm7.168 21.5a1.791 1.791 0 1 1 1.791 1.791 1.791 1.791 0 0 1-1.791-1.789z",
    transform: "translate(418.056 316.5) translate(8.959 3.583)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "rgba(255,217,45,0.58)",
    transform: "translate(442 339)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.6603237c09aacd32448605a83c37f374.svg";
export { ForwardRef as ReactComponent };